export default __webpack_public_path__ + "static/media/i_bus-gen_gy_tagless.757654fe.svg";